<template>
  <div class="bid-file-preview-history">
    <div class="preview-card">
      <div class="preview-card-header">
        <div class="preview-card-header__title">项目列表</div>
      </div>
      <div class="preview-card-body flex-col">
        <el-form size="small" inline label-suffix="：" :model="filterForm">
          <el-form-item label="预览日期">
            <date-range-picker v-model="timeRange" />
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input
              v-model.trim="filterForm.orderName"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item>
            <div class="flex">
              <el-button type="primary" size="small" @click="handleSearch">
                查询
              </el-button>
              <el-button size="small" @click="handleReset">
                重置
              </el-button>
            </div>
          </el-form-item>
        </el-form>

        <!-- 列表 -->
        <div v-if="history.length > 0" class="history-list">
          <div
            v-for="(item, index) in history"
            :key="index"
            class="history-item"
          >
            <div class="flex col-top row-between m-b-8">
              <div class="font-color-main text-bold history-item-order">
                {{ item.orderName || '-' }}
              </div>
              <el-button
                type="text"
                @click="openPreviewDialog(item)"
              >标书预览</el-button>
            </div>
            <div class="flex col-center font-color-third">
              <div
                class="text-ellipsis"
                :title="item.purchaseCompanyName"
                style="width: 400px"
              >
                采购单位：{{ item.purchaseCompanyName || '-' }}
              </div>
              <div>预览日期：{{ item.viewTime | formatDate }}</div>
            </div>
          </div>
        </div>

        <div v-else class="history-list">
          <el-empty
            description="暂无数据"
            :image="require('@/assets/images/personal-center/empty.png')"
            :image-size="64"
          />
        </div>

        <jczh-pagination
          v-if="total > 0"
          style="width: 100%"
          :total="total"
          :page.sync="page"
          :limit.sync="size"
          @pagination="getList"
        />
      </div>
    </div>

    <!-- 招标文件列表弹窗 -->
    <bid-file-preview-dialog
      :visible.sync="bidFilePreviewVisible"
      :order-id="bidFilePreviewInfo.orderId || 0"
    />
  </div>
</template>

<script>
import DateRangePicker from '@/components/DateRangePicker'
import BidFilePreviewDialog from '@/components/BidFilePreviewDialog'

import { listFilterMixin } from 'jczh-ui'
import { queryBidFilePreviewServiceListApi } from '@/api/value-added-service'

/**
 * @description 招标文件预览历史
 */
export default {
  name: 'BidFilePreviewHistory',

  components: {
    BidFilePreviewDialog,
    DateRangePicker
  },

  filters: {
    formatDate(value) {
      // 去除时分秒
      return value.split(' ')[0] || '-'
    }
  },

  mixins: [listFilterMixin],

  data() {
    return {
      // 标书预览历史记录/项目列表
      history: [],
      total: 0,
      // 过滤表单
      filterForm: {
        // 预览开始时间
        previewTimeStart: '',
        // 预览结束时间
        previewTimeEnd: '',
        // 项目名称
        orderName: ''
      },

      // 展示招标文件列表
      bidFilePreviewVisible: false,
      // 当前要查看的招标文件项目
      bidFilePreviewInfo: {}
    }
  },

  computed: {
    timeRange: {
      get() {
        return [
          this.filterForm.previewTimeStart,
          this.filterForm.previewTimeEnd
        ]
      },
      set(val) {
        if (val?.length) {
          this.filterForm.previewTimeStart = val[0]
          this.filterForm.previewTimeEnd = val[1]
        }
      }
    }
  },

  created() {
    this.getList()
  },

  methods: {
    getList() {
      this.epitaxy()

      const requestParams = {
        page: this.page,
        size: this.size,
        ...this.filterForm
      }
      queryBidFilePreviewServiceListApi(requestParams)
        .then(res => {
          this.history = res.data?.records || []
          this.total = res.data?.total || 0
        })
        .catch(err => {
          console.error('获取招标文件列表失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 打开招标文件列表
     */
    openPreviewDialog(item) {
      this.bidFilePreviewVisible = true
      this.bidFilePreviewInfo = item
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-file-preview-history {
  .preview-card {
    width: 100%;
    border-radius: 4px;
    background: $white-color;
    padding: 24px;

    .preview-card-header {
      margin-bottom: 24px;
      display: flex;
      align-items: flex-end;

      .preview-card-header__title {
        font-size: 16px;
        color: $text-color;
        @include text-bold;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 16px;
          background: $primary-color;
          margin-right: 6px;
          vertical-align: -12%;
        }
      }

      .preview-card-header__tip {
        font-size: 12px;
        color: $text-second-color;
        margin-left: 10px;
      }
    }

    .preview-card-body {
      display: flex;
      align-items: center;

      .preview-section {
        flex: 1;
        background: $info-fifth-color;
        border-radius: 4px;
        padding: 16px 24px;
        &:not(:last-child) {
          margin-right: 24px;
        }
      }
    }
  }
}

.history-list {
  width: 100%;

  .history-item {
    padding: 16px 0;
    border-top: 1px solid $info-fourth-color;

    &:last-child {
      border-bottom: 1px solid $info-fourth-color;
    }

    .history-item-order {
      width: 90%;
      word-break: break-all;
    }
  }
}

.dialog-bid-file-preview {
  padding: 0 16px 24px;

  .preview-item {
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:last-child) {
      border-bottom: 1px solid $info-fourth-color;
    }
  }
}
</style>
